import React, { Component } from 'react'
import { withStyles } from '@material-ui/styles'
import { EmployeeForm } from './../forms'
import { Dashboard } from './../layouts'

const styles = theme => ({
    //
})

class EmployeeNew extends Component {
    constructor(props) {
        super(props)
        
        this.state = {
            title: 'Ажилчид'
        }
    }

    render() {
        const { title } = this.state
        return (
            <Dashboard title={title}>
                <EmployeeForm 
                    path="employees"
                    method="post"
                    message="Амжилттай нэмэгдлээ"
                />
            </Dashboard>
        )
    }
}

export default withStyles(styles)(EmployeeNew)
